module.exports = __webpack_public_path__ + "static/media/fiore.4b2eeb9f.jpeg";